module.exports = __webpack_public_path__ + "static/media/comercial-icon.f5a38e3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/servicios/comercial-icon.svg
// module id = 167
// module chunks = 0